import BaseLine from "../../sisu/chart/BaseLine.sisu";

const NeoLine = BaseLine

export default NeoLine